import React from "react";
import "./newlaunch.scss";
import New1 from "./new1/new1.jsx";
import New3 from "./new3/new3.jsx";
import New4 from "./new4/new4.jsx";
import Promonew1 from "./new1/promonew1.jsx";
import Newlaunchruko from "./newlaunchruko/newlaunchruko.jsx";
import GrandiaAvenue from "./grandiaavenue/GrandiaAvenue.jsx";

const newlaunch = () => {
  return (
    <div id="new" className="container1">
      <div className="judul-newlaunch1">
        <div id="newlaunch" className="judul1">
          NEW LAUNCHING{" "}
        </div>
        <div className="judul2">Palma Grandia</div>
        <GrandiaAvenue />
        <br />
        <br />
        <br />
      </div>
    </div>
  );
};

export default newlaunch;
